import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const SortNumber = forwardRef(function SortNumber(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.287 2.307A.75.75 0 0 1 17.75 3v5.25H19a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5h1.25V4.81l-.72.72a.75.75 0 1 1-1.06-1.06l2-2a.75.75 0 0 1 .817-.163ZM7 5.25a.75.75 0 0 1 .75.75v10.19l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V6A.75.75 0 0 1 7 5.25ZM19.75 13a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3.25v1.5H15a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 .75-.75v-6Zm-1.5.75v1.5h-2.5v-1.5h2.5Z"
        fill="currentColor"
      />
    </Icon>
  );
});
